import * as yup from "yup";

export const PullEventsValidation = yup.object().shape({
	marketplace: yup.string().required("Marketplace is required"),
	eventID: yup
		.string()
		.trim()
		.default("")
		.notRequired(),
	search: yup
		.string()
		.trim()
		.default("")
		.when(["eventID", "marketplace"], {
			is: (eventID: string, marketplace: string) =>
				!eventID && marketplace !== "AXS",
			then: (schema) => schema.required("Event name is required"),
			otherwise: (schema) => schema.notRequired(),
		}),
	startDate: yup
		.string()
		.when("eventID", {
			is: (val: string) => !val,
			then: (schema) => schema.required("Start date is required"),
			otherwise: (schema) => schema.notRequired(),
		}),
	endDate: yup
		.string()
		.when("eventID", {
			is: (val: string) => !val,
			then: (schema) => schema.required("End date is required"),
			otherwise: (schema) => schema.notRequired(),
		}),
});

export type PullEventsFormValues = yup.InferType<typeof PullEventsValidation>;

export const pullEventsDefaultValues: PullEventsFormValues = {
	search: "",
	eventID: "",
	marketplace: "",
	startDate: "",
	endDate: "",
};
